import { applyMiddleware, compose, createStore } from 'redux';
// import { loadState, saveState } from './localStorage';

import { createBrowserHistory } from 'history';
import createRootReducer from '../reducers';
import { loadingBarMiddleware } from 'react-redux-loading-bar';
import notificationMiddleware from './notificationMiddleware';
import promiseMiddleware from 'redux-promise-middleware';
import { routerMiddleware } from 'connected-react-router';
// import throttle from 'lodash/throttle';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
import createEncryptor from 'redux-persist-transform-encrypt';
import localForage from 'localforage';

export const history = createBrowserHistory({
  basename: '/manajer/',
});

const encryptor = createEncryptor({
  secretKey: '$2a$10$P49R1e0IfGwQikRls7EozO5JUdXC2I5BHXuAIOK0mP7q0.bo9RwSu',
  onError: function(error) {
    // Handle the error.
    console.log('encrypt error');
  },
});

localForage.config({
  name: 'S0xDIEdlbmVyYXNpIDI=',
  storeName: '$2a$10$fcpXP9AKfBjp2ztcML19YONk4tR0oXnuuSX5HP375.OVe.LjWRmzi',
});

const persistConfig = {
  key: 'a2xjMnRpa2JwcGs=',
  storage: localForage,
  transforms: [encryptor],
};

const pReducer = persistReducer(persistConfig, createRootReducer(history));

const middlewares = [
  thunk,
  notificationMiddleware,
  promiseMiddleware,
  routerMiddleware(history),
  loadingBarMiddleware(),
];

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const persistedState = loadState();

const store = createStore(
  pReducer,
  // persistedState,
  // composeEnhancers(applyMiddleware(...middlewares)),
  compose(applyMiddleware(...middlewares))
);
// store.subscribe(
//   throttle(() => {
//     saveState({
//       settings: store.getState().settings,
//       userprofile: store.getState().userprofile,
//       coursedata: store.getState().coursedata,
//       roledata: store.getState().roledata,
//       authoritydata: store.getState().authoritydata,
//     });
//   }, 1000)
// );

const persistor = persistStore(store);

export default store;
export { persistor, store };
